export default {
  feeModels: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  rfIndexers: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  portfolioModels: {
    loading: false,
    lastUpdate: null,
    data: [
      { nome: 'Agressivo' },
      { nome: 'Conservador' },
      { nome: 'Moderado' },
    ],
  },
  currencies: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
